export type OpenlayersExtent = number[];
